import { styled, keyframes } from '@gbm-tech/styles';
import * as PopoverPrimitive from '@radix-ui/react-popover';

export const StyledPopoverRoot = styled(PopoverPrimitive.Root, {});

const slideRightAndFade = keyframes({
  '0%': { opacity: 0, transform: 'translateX(10px)' },
  '100%': { opacity: 1, transform: 'translateX(0)' },
});

export const StyledPopoverWrapper = styled(PopoverPrimitive.Content, {
  overflow: 'hidden',
  zIndex: 110,

  backgroundColor: '$background',
  border: '1px solid #dae0e7',
  borderRadius: '8px',
  boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)',

  '&.PopoverContent': {
    animationDuration: '0.2s',
    animationTimingFunction: 'cubic',
  },

  '&[data-side="right"]': { animationName: slideRightAndFade },

  '.PopoverArrow': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    width: '2.4rem',
    height: '0.8rem',
    paddingBottom: '0.2rem',
    fill: 'white',
  },
});
